import { EventData } from "../components/pages/Events/ManageEvents/ManageEvents";
import { eventData } from "../components/pages/MyChamber/analyticsData";

/**
 * Generates fake event data for testing and development
 * @param count Number of events to generate (defaults to 20)
 * @param upcomingCount Number of upcoming events (defaults to 3)
 * @returns Array of EventData objects
 */
export const generateFakeEventData = (
  count: number = 20,
  upcomingCount: number = 3
): EventData[] => {
  const eventNames = [
    "Annual Business Summit",
    "Networking Breakfast",
    "Small Business Expo",
    "Leadership Conference",
    "Tech Innovation Showcase",
    "Women in Business Luncheon",
    "Economic Development Forum",
    "Chamber Golf Tournament",
    "New Member Orientation",
    "Holiday Mixer",
    "Entrepreneurship Workshop",
    "Community Awards Gala",
    "Industry Roundtable",
    "Job Fair",
    "Marketing Masterclass",
    "Business After Hours",
    "Quarterly Membership Meeting",
    "Legislative Breakfast",
    "Young Professionals Mixer",
    "International Trade Symposium",
  ];

  const locations = [
    "Grand Ballroom",
    "Convention Center",
    "City Hall",
    "Downtown Hotel",
    "Community Center",
    "Golf Club",
    "Local University",
    "Business Park",
    "Riverfront Venue",
    "Arts Center",
  ];

  const currentDate = new Date();
  const oneDay = 24 * 60 * 60 * 1000;

  // Create upcoming events
  const upcomingEvents = Array.from(
    { length: Math.min(upcomingCount, count) },
    (_, i) => {
      const futureDate = new Date(
        currentDate.getTime() + (i + 1) * 15 * oneDay
      );
      return {
        id: `event-${i}`,
        name: eventNames[i % eventNames.length],
        status: "upcoming" as const,
        ticketRevenue: 0, // No revenue yet for upcoming events
        sponsorshipRevenue: 0, // No revenue yet for upcoming events
        date: futureDate.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }),
        attendeeCount: Math.floor(Math.random() * 50) + 50,
        location: locations[Math.floor(Math.random() * locations.length)],
        eventType:
          eventData.eventsByType[
            Math.floor(Math.random() * eventData.eventsByType.length)
          ].name,
      };
    }
  );

  // Create completed events
  const completedCount = count - upcomingCount;
  const completedEvents = Array.from({ length: completedCount }, (_, i) => {
    const pastDate = new Date(currentDate.getTime() - (i + 1) * 20 * oneDay);
    const totalRevenue = Math.floor(Math.random() * 3000) + 2000; // Total revenue between $2000-$5000
    const ticketRevenue = Math.floor(
      totalRevenue * (0.6 + Math.random() * 0.3)
    ); // 60-90% from tickets
    const sponsorshipRevenue = totalRevenue - ticketRevenue; // Remaining from sponsorships

    return {
      id: `event-${i + upcomingCount}`,
      name: eventNames[(i + upcomingCount) % eventNames.length],
      status: "completed" as const,
      ticketRevenue,
      sponsorshipRevenue,
      date: pastDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
      attendeeCount: Math.floor(Math.random() * 100) + 50,
      location: locations[Math.floor(Math.random() * locations.length)],
      eventType:
        eventData.eventsByType[
          Math.floor(Math.random() * eventData.eventsByType.length)
        ].name,
    };
  });

  return [...upcomingEvents, ...completedEvents];
};
